import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import audio from '../../utils/audio';
import BonusInterface from '../../api/BonusInterface';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Emitter from '../../services/EmitterService';
import { EVENT_EMITTER_TYPE } from '../../constants';
import { ACTION_COMMANDS_EVENT_TYPE, ACTION_COMMANDS_TYPE } from '../../api/ActionCommandsInterface/constants';
import { debounce } from 'lodash';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var WelcomeBonus = /*#__PURE__*/function (_Component) {
  _inherits(WelcomeBonus, _Component);

  var _super = _createSuper(WelcomeBonus);

  function WelcomeBonus(props) {
    var _this;

    _classCallCheck(this, WelcomeBonus);

    _this = _super.call(this, props);

    _this.eventEmitterOnProcesssedRequest = function () {
      var _this$props$actionCom, _this$props$actionCom2, _this$props$actionCom3, _this$props$actionCom4, _this$props$actionCom5, _this$props$actionCom6, _this$props$actionCom7;

      Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
        actionType: ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST,
        data: {
          event: ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL,
          modalType: (_this$props$actionCom = _this.props.actionCommands) === null || _this$props$actionCom === void 0 ? void 0 : _this$props$actionCom.modal.modalType,
          triggerExecution: (_this$props$actionCom2 = _this.props.actionCommands) === null || _this$props$actionCom2 === void 0 ? void 0 : (_this$props$actionCom3 = _this$props$actionCom2.modal.buttons[0]) === null || _this$props$actionCom3 === void 0 ? void 0 : (_this$props$actionCom4 = _this$props$actionCom3.onClickAction) === null || _this$props$actionCom4 === void 0 ? void 0 : _this$props$actionCom4.triggerExecution,
          payload: (_this$props$actionCom5 = _this.props.actionCommands) === null || _this$props$actionCom5 === void 0 ? void 0 : (_this$props$actionCom6 = _this$props$actionCom5.modal.buttons[0]) === null || _this$props$actionCom6 === void 0 ? void 0 : (_this$props$actionCom7 = _this$props$actionCom6.onClickAction) === null || _this$props$actionCom7 === void 0 ? void 0 : _this$props$actionCom7.payload
        }
      });
    };

    _this.clickHandler = function () {
      audio.onClick();
      audio.playCoinSfx();
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
      QueryParamProxy.modalPromiseAccept();
    };

    _this.debounceClickHandler = debounce(_this.clickHandler, 1000);
    _this.buttonClicked = false;
    return _this;
  }

  _createClass(WelcomeBonus, [{
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
                  actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND
                });
                _context.next = 3;
                return BonusInterface.collectWelcomeBonus();

              case 3:
                response = _context.sent;

                if (response.success) {
                  this.props.setIsWelcomeBonusConsumed(true);
                  this.eventEmitterOnProcesssedRequest();
                  audio.playCoinSfx();
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          welcomeBonus = _this$props.welcomeBonus,
          render = _this$props.render;
      var bonusAmount = format(welcomeBonus);
      return render({
        bonusAmount: bonusAmount,
        clickHandler: this.debounceClickHandler
      });
    }
  }]);

  return WelcomeBonus;
}(Component);

export { WelcomeBonus as default };